<template>
  <view
    class="pb-safe w-full bg-white items-center h-70 flex fixed bottom-0 left-0 z-10 shadow-[0px_0px_24px_0px_rgba(0,0,0,0.12)]"
  >
    <template v-for="(item, index) in tabbarStore.tabbarList" :key="index">
      <view v-if="index !== 2" class="flex-1 text-center" @click="tabbarStore.setCurrIndex(index)">
        <image
          v-if="index === tabbarStore.currIndex"
          :src="assetsConfig[item.icon].activeIcon"
          class="h-26 w-26 mx-auto"
          mode="aspectFit"
        />
        <image
          v-else
          :src="assetsConfig[item.icon].icon"
          class="h-26 w-26 mx-auto"
          mode="aspectFit"
        />
        <view
          :class="{
            '!text-#333': index === tabbarStore.currIndex,
          }"
          class="text-12 text-#999"
          v-if="assetsConfig[item.icon].title"
        >
          {{ assetsConfig[item.icon].title }}
        </view>
        <view
          class="mx-auto mt-2 w-10 h-2 shrink-0 border-rd-2"
          :class="{ 'bg-[#97FDE8]': index === tabbarStore.currIndex }"
        ></view>
      </view>
      <template v-else>
        <view class="relative -top-20 w-70 h-70" @click="tabbarStore.setCurrIndex(index)">
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <!-- 外圈旋转 + 柔和渐变 -->
            <circle cx="40" cy="40" r="40" fill="url(#paint0_linear)">
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 40 40"
                to="360 40 40"
                dur="3s"
                repeatCount="indefinite"
              />
            </circle>

            <!-- 内圈（间距缩小） -->
            <circle cx="40" cy="40" r="30" fill="url(#paint1_linear)" />

            <!-- 向下箭头浮动 -->
            <path
              d="M34.5757 47.4243C34.8101 47.6586 35.19 47.6586 35.4243 47.4243L39.2426 43.6059C39.477 43.3716 39.477 42.9917 39.2426 42.7574C39.0083 42.523 38.6284 42.523 38.3941 42.7574L35 46.1515L31.6059 42.7574C31.3716 42.523 30.9917 42.523 30.7574 42.7574C30.523 42.9917 30.523 43.3716 30.7574 43.6059L34.5757 47.4243ZM34.4 32L34.4 47L35.6 47L35.6 32L34.4 32Z"
              fill="rgba(255,255,255,0.9)"
              stroke="rgba(255,255,255,0.9)"
              stroke-width="1"
            >
              <animateTransform
                attributeName="transform"
                type="translate"
                values="0 0; 0 2; 0 0"
                dur="1s"
                repeatCount="indefinite"
              />
            </path>

            <!-- 向上箭头浮动 -->
            <path
              d="M44.4243 31.5757C44.19 31.3414 43.8101 31.3414 43.5757 31.5757L39.7574 35.3941C39.523 35.6284 39.523 36.0083 39.7574 36.2426C39.9917 36.477 40.3716 36.477 40.6059 36.2426L44 32.8485L47.3941 36.2426C47.6284 36.477 48.0083 36.477 48.2426 36.2426C48.477 36.0083 48.477 35.6284 48.2426 35.3941L44.4243 31.5757ZM44.6 47L44.6 32L43.4 32L43.4 47L44.6 47Z"
              fill="rgba(255,255,255,0.9)"
              stroke="rgba(255,255,255,0.9)"
              stroke-width="1"
            >
              <animateTransform
                attributeName="transform"
                type="translate"
                values="0 0; 0 -2; 0 0"
                dur="1s"
                repeatCount="indefinite"
              />
            </path>

            <defs>
              <!-- 柔和渐变 -->
              <linearGradient
                id="paint0_linear"
                x1="13.7931"
                y1="7.58621"
                x2="61.3793"
                y2="71.7241"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#DBE3EE">
                  <animate
                    attributeName="stop-color"
                    values="#DBE3EE;#C4D7F3;#DBE3EE"
                    dur="3s"
                    repeatCount="indefinite"
                  />
                </stop>
                <stop offset="0.5" stop-color="#BFD8F8">
                  <animate
                    attributeName="stop-color"
                    values="#BFD8F8;#A3C6F1;#BFD8F8"
                    dur="3s"
                    repeatCount="indefinite"
                  />
                </stop>
                <stop offset="1" stop-color="#AFBDE1">
                  <animate
                    attributeName="stop-color"
                    values="#AFBDE1;#A0B8DD;#AFBDE1"
                    dur="3s"
                    repeatCount="indefinite"
                  />
                </stop>
              </linearGradient>

              <linearGradient
                id="paint1_linear"
                x1="21"
                y1="16.5"
                x2="55.5"
                y2="63"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#1183E6" />
                <stop offset="0.5" stop-color="#0F95E0" />
                <stop offset="1" stop-color="#445AE9" />
              </linearGradient>
            </defs>
          </svg>
        </view>
      </template>
    </template>
  </view>
</template>
<script setup lang="ts">
import TABBAR_HOME_ICON from '@/static/tabbar/navbar-icon-1.png'
import TABBAR_HOME_ICON_ACTIVE from '@/static/tabbar/navbar-icon-1-c.png'
import TABBAR_NFT_ICON from '@/static/tabbar/navbar-icon-2.png'
import TABBAR_NFT_ICON_ACTIVE from '@/static/tabbar/navbar-icon-2-c.png'
// import TABBAR_RECOMMEND_ICON from '@/static/tabbar/navbar-icon-3.png'
// import TABBAR_RECOMMEND_ICON_ACTIVE from '@/static/tabbar/navbar-icon-3-c.png'
import TABBAR_WHITE_PAPER_ICON from '@/static/tabbar/navbar-icon-4.png'
import TABBAR_WHITE_PAPER_ICON_ACTIVE from '@/static/tabbar/navbar-icon-4-c.png'
import TABBAR_MY_ICON from '@/static/tabbar/navbar-icon-5.png'
import TABBAR_MY_ICON_ACTIVE from '@/static/tabbar/navbar-icon-5-c.png'
import { useTabbarStore } from '@/store/tabbar'
const assetsConfig = {
  home: {
    icon: TABBAR_HOME_ICON,
    activeIcon: TABBAR_HOME_ICON_ACTIVE,
    title: '资讯',
  },
  market: {
    icon: TABBAR_NFT_ICON,
    activeIcon: TABBAR_NFT_ICON_ACTIVE,
    title: '行情',
  },
  team: {
    icon: TABBAR_WHITE_PAPER_ICON,
    activeIcon: TABBAR_WHITE_PAPER_ICON_ACTIVE,
    title: '团队',
  },
  my: {
    icon: TABBAR_MY_ICON,
    activeIcon: TABBAR_MY_ICON_ACTIVE,
    title: '我的',
  },
}

const tabbarStore = useTabbarStore()

defineOptions({
  name: 'CustomTabbar',
})

onLoad(() => {
  // 解决原生 tabBar 未隐藏导致有2个 tabBar 的问题

  uni.hideTabBar()

})
</script>
